(function() {
  document.addEventListener('DOMContentLoaded', function() {
    const tabContainers = document.querySelectorAll('.submenu-category-container');

    tabContainers.forEach(container => {
      const tabNames = container.querySelectorAll('.tab-name');

      tabNames.forEach(tab => {
        tab.addEventListener('click', function() {
          const index = this.dataset.tabIndex;  
          const containerId = this.dataset.containerId;  

          // 移除所有 tab 和对应内容的 active 类
          tabNames.forEach(t => {
            t.classList.remove('active');
            t.setAttribute('aria-selected', 'false');  
          });

          const tabContents = container.querySelectorAll('.category-tab-content');
          tabContents.forEach(tc => tc.classList.remove('active')); 

          // 添加 active 类到当前 tab
          this.classList.add('active');
          this.setAttribute('aria-selected', 'true');  

          // 动态构建 ID
          const activeContentId = `tab-content-${containerId}-${index}`;
          console.log(activeContentId);
          const activeContent = container.querySelector(`#${activeContentId}`);
          
          if (activeContent) {
            activeContent.classList.add('active');
          } else { 
          }
        });
      });
    });
  });
})();
